import Vue from 'vue'
import App from './App.vue'
import router from './router'

import request from "@g1100100/rest.request"
import vueUI from "@g1100100/vue-ui"

import "@g1100100/vue-ui/lib/vue-ui.css"
Vue.prototype.$http = request;
Vue.use(vueUI);
Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')